import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/regenerator";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { connectivity, type } from "../common.speech/Exports";
import { AudioSourceErrorEvent, AudioSourceInitializingEvent, AudioSourceOffEvent, AudioSourceReadyEvent, AudioStreamNodeAttachedEvent, AudioStreamNodeAttachingEvent, AudioStreamNodeDetachedEvent, AudioStreamNodeErrorEvent, ChunkedArrayBufferStream, createNoDashGuid, Deferred, Events, EventSource } from "../common/Exports";
import { AudioStreamFormat, AudioStreamFormatImpl } from "../sdk/Audio/AudioStreamFormat";
export var AudioWorkletSourceURLPropertyName = "MICROPHONE-WorkletSourceUrl";
export var MicAudioSource = /*#__PURE__*/function () {
  function MicAudioSource(privRecorder, deviceId, audioSourceId, mediaStream) {
    var _this = this;

    _classCallCheck(this, MicAudioSource);

    this.privRecorder = privRecorder;
    this.deviceId = deviceId;
    this.privStreams = {};

    this.turnOn = function () {
      if (_this.privInitializeDeferral) {
        return _this.privInitializeDeferral.promise;
      }

      _this.privInitializeDeferral = new Deferred();

      try {
        _this.createAudioContext();
      } catch (error) {
        if (error instanceof Error) {
          var typedError = error;

          _this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
        } else {
          _this.privInitializeDeferral.reject(error);
        }

        return _this.privInitializeDeferral.promise;
      }

      var nav = window.navigator;
      var getUserMedia = nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;

      if (!!nav.mediaDevices) {
        getUserMedia = function getUserMedia(constraints, successCallback, errorCallback) {
          nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
        };
      }

      if (!getUserMedia) {
        var errorMsg = "Browser does not support getUserMedia.";

        _this.privInitializeDeferral.reject(errorMsg);

        _this.onEvent(new AudioSourceErrorEvent(errorMsg, "")); // mic initialized error - no streamid at this point

      } else {
        var next = function next() {
          _this.onEvent(new AudioSourceInitializingEvent(_this.privId)); // no stream id


          if (_this.privMediaStream && _this.privMediaStream.active) {
            _this.onEvent(new AudioSourceReadyEvent(_this.privId));

            _this.privInitializeDeferral.resolve();
          } else {
            getUserMedia({
              audio: _this.deviceId ? {
                deviceId: _this.deviceId
              } : true,
              video: false
            }, function (mediaStream) {
              _this.privMediaStream = mediaStream;

              _this.onEvent(new AudioSourceReadyEvent(_this.privId));

              _this.privInitializeDeferral.resolve();
            }, function (error) {
              var errorMsg = "Error occurred during microphone initialization: ".concat(error);

              _this.privInitializeDeferral.reject(errorMsg);

              _this.onEvent(new AudioSourceErrorEvent(_this.privId, errorMsg));
            });
          }
        };

        if (_this.privContext.state === "suspended") {
          // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
          // https://github.com/WebAudio/web-audio-api/issues/790
          _this.privContext.resume().then(next).catch(function (reason) {
            _this.privInitializeDeferral.reject("Failed to initialize audio context: ".concat(reason));
          });
        } else {
          next();
        }
      }

      return _this.privInitializeDeferral.promise;
    };

    this.id = function () {
      return _this.privId;
    };

    this.attach = function (audioNodeId) {
      _this.onEvent(new AudioStreamNodeAttachingEvent(_this.privId, audioNodeId));

      return _this.listen(audioNodeId).then(function (stream) {
        _this.onEvent(new AudioStreamNodeAttachedEvent(_this.privId, audioNodeId));

        return {
          detach: function detach() {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      stream.readEnded();
                      delete this.privStreams[audioNodeId];
                      this.onEvent(new AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                      return _context.abrupt("return", this.turnOff());

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));
          },
          id: function id() {
            return audioNodeId;
          },
          read: function read() {
            return stream.read();
          }
        };
      });
    };

    this.detach = function (audioNodeId) {
      if (audioNodeId && _this.privStreams[audioNodeId]) {
        _this.privStreams[audioNodeId].close();

        delete _this.privStreams[audioNodeId];

        _this.onEvent(new AudioStreamNodeDetachedEvent(_this.privId, audioNodeId));
      }
    };

    this.listen = function (audioNodeId) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var stream, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.turnOn();

              case 2:
                stream = new ChunkedArrayBufferStream(this.privOutputChunkSize, audioNodeId);
                this.privStreams[audioNodeId] = stream;
                _context2.prev = 4;
                this.privRecorder.record(this.privContext, this.privMediaStream, stream);
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](4);
                this.onEvent(new AudioStreamNodeErrorEvent(this.privId, audioNodeId, _context2.t0));
                throw _context2.t0;

              case 12:
                result = stream;
                return _context2.abrupt("return", result);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 8]]);
      }));
    };

    this.onEvent = function (event) {
      _this.privEvents.onEvent(event);

      Events.instance.onEvent(event);
    };

    this.createAudioContext = function () {
      if (!!_this.privContext) {
        return;
      }

      _this.privContext = AudioStreamFormatImpl.getAudioContext(MicAudioSource.AUDIOFORMAT.samplesPerSec);
    };

    this.privOutputChunkSize = MicAudioSource.AUDIOFORMAT.avgBytesPerSec / 10;
    this.privId = audioSourceId ? audioSourceId : createNoDashGuid();
    this.privEvents = new EventSource();
    this.privMediaStream = mediaStream || null;
    this.privIsClosing = false;
  }

  _createClass(MicAudioSource, [{
    key: "format",
    get: function get() {
      return Promise.resolve(MicAudioSource.AUDIOFORMAT);
    }
  }, {
    key: "blob",
    get: function get() {
      return Promise.reject("Not implemented for Mic input");
    }
  }, {
    key: "turnOff",
    value: function turnOff() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var streamId, stream;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (streamId in this.privStreams) {
                  if (streamId) {
                    stream = this.privStreams[streamId];

                    if (stream) {
                      stream.close();
                    }
                  }
                }

                this.onEvent(new AudioSourceOffEvent(this.privId)); // no stream now

                if (!this.privInitializeDeferral) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 5;
                return this.privInitializeDeferral;

              case 5:
                this.privInitializeDeferral = null;

              case 6:
                _context3.next = 8;
                return this.destroyAudioContext();

              case 8:
                return _context3.abrupt("return");

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "events",
    get: function get() {
      return this.privEvents;
    }
  }, {
    key: "deviceInfo",
    get: function get() {
      return this.getMicrophoneLabel().then(function (label) {
        return {
          bitspersample: MicAudioSource.AUDIOFORMAT.bitsPerSample,
          channelcount: MicAudioSource.AUDIOFORMAT.channels,
          connectivity: connectivity.Unknown,
          manufacturer: "Speech SDK",
          model: label,
          samplerate: MicAudioSource.AUDIOFORMAT.samplesPerSec,
          type: type.Microphones
        };
      });
    }
  }, {
    key: "setProperty",
    value: function setProperty(name, value) {
      if (name === AudioWorkletSourceURLPropertyName) {
        this.privRecorder.setWorkletUrl(value);
      } else {
        throw new Error("Property '" + name + "' is not supported on Microphone.");
      }
    }
  }, {
    key: "getMicrophoneLabel",
    value: function getMicrophoneLabel() {
      var _this2 = this;

      var defaultMicrophoneName = "microphone"; // If we did this already, return the value.

      if (this.privMicrophoneLabel !== undefined) {
        return Promise.resolve(this.privMicrophoneLabel);
      } // If the stream isn't currently running, we can't query devices because security.


      if (this.privMediaStream === undefined || !this.privMediaStream.active) {
        return Promise.resolve(defaultMicrophoneName);
      } // Setup a default


      this.privMicrophoneLabel = defaultMicrophoneName; // Get the id of the device running the audio track.

      var microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId; // If the browser doesn't support getting the device ID, set a default and return.

      if (undefined === microphoneDeviceId) {
        return Promise.resolve(this.privMicrophoneLabel);
      }

      var deferred = new Deferred(); // Enumerate the media devices.

      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        var _iterator = _createForOfIteratorHelper(devices),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var device = _step.value;

            if (device.deviceId === microphoneDeviceId) {
              // Found the device
              _this2.privMicrophoneLabel = device.label;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        deferred.resolve(_this2.privMicrophoneLabel);
      }, function () {
        return deferred.resolve(_this2.privMicrophoneLabel);
      });
      return deferred.promise;
    }
  }, {
    key: "destroyAudioContext",
    value: function destroyAudioContext() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var hasClose;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.privContext) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                this.privRecorder.releaseMediaResources(this.privContext); // This pattern brought to you by a bug in the TypeScript compiler where it
                // confuses the ("close" in this.privContext) with this.privContext always being null as the alternate.
                // https://github.com/Microsoft/TypeScript/issues/11498

                hasClose = false;

                if ("close" in this.privContext) {
                  hasClose = true;
                }

                if (!hasClose) {
                  _context4.next = 14;
                  break;
                }

                if (this.privIsClosing) {
                  _context4.next = 12;
                  break;
                }

                // The audio context close may take enough time that the close is called twice
                this.privIsClosing = true;
                _context4.next = 10;
                return this.privContext.close();

              case 10:
                this.privContext = null;
                this.privIsClosing = false;

              case 12:
                _context4.next = 17;
                break;

              case 14:
                if (!(null !== this.privContext && this.privContext.state === "running")) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 17;
                return this.privContext.suspend();

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return MicAudioSource;
}();
MicAudioSource.AUDIOFORMAT = AudioStreamFormat.getDefaultInputFormat();